import React from "react";
import QualityRetentionPage from "./quality-retention";

export default function TroubleshootingPage() {
  return <QualityRetentionPage />;
}
